import { createContext } from 'react';

import { WizardValues } from '../types';

export const WizardContext = createContext<WizardValues | null>(null);
